import React, { useEffect, useState } from "react";
import "./GazetteFinder.css";
import Modal from "../pdf-modal/Modal";
import api from "../../../services/baseUrl";
import { useLocation } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import HighlightedText from "../../../components/HighlightKeyword";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TiArrowUnsorted } from "react-icons/ti";

export default function Result() {
  const [data, setData] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemId, setItemId] = useState(null);
  const location = useLocation();
  const item = location.state?.request;
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalResults, settotalResults] = useState(0);
  const query = item.query;
  const queryParts = query.split(" | ");
  const isSingleValue = queryParts.every((part) => !part.includes(":"));
  const [itemState, setItemState] = useState("");
  const [addPageNumberModalOpen, setAddPageNumberModalOpen] = useState(false);
  const [requestPageNumber, setRequestPageNumber] = useState("");
  const [currentRequest, setCurrentRequest] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.post("/ewarta/search/cont/egazette", item);
        setData(response.data.results);
      } catch (e) {}
    };

    const fetchState = async () => {
      try {
        const response = await api.get(`api/egazette-documents/libraries/all`, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (item.stateId) {
          const state = response.data.find((s) => s.id === item.stateId);
          setItemState(state.name);
        }

        if (item.libraryId) {
          for (const state of response.data) {
            if (state.library.some((lib) => lib.libraryId === item.libraryId)) {
              setItemState(state.name);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching libraries:", error);
      }
    };
    fetchData();
    fetchState();
  }, [item]);

  useEffect(() => {
    const endOffset = itemOffset + limit;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / limit));
    settotalResults(data.length);
  }, [itemOffset, limit, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % data.length;
    setItemOffset(newOffset);

    const syariahBody = document.querySelector(".egazette-search-body");
    if (syariahBody) {
      const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
    }
    setCurrentPage(event.selected);
  };
  const fetchPDF = async (uuid) => {
    try {
      const response = await api.post(
        "/ewarta/document/pdf",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
  };

  const openModal = (uuid, startPage) => {
    setIsModalOpen(true);
    setPageNumber(startPage);
    setItemId(uuid);
    fetchPDF(uuid);
  };

  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
  };

  const validatePageNumber = async () => {
    const regex = /^(\d+(-\d+)?)(,(\d+(-\d+)?))*$/;
    if (requestPageNumber === "") {
      toast.warning("Please input a page number.");
      return;
    }
    if (!regex.test(requestPageNumber)) {
      toast.warning("Please ensure the page number format is correct.");
      return;
    }

    try {
      const response = await api.post("/ewarta/request/update", {
        requestId: item.id,
        userId: item.userId.userId,
        fileUUID: currentRequest.fileUUID,
        pageNumber: requestPageNumber,
      });

      toast.success(response.data);
      setAddPageNumberModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="wartaState-container-result">
      <div style={{ marginBottom: "1rem" }}>
        <h3 style={{ marginBottom: "0.3rem" }}>State: {itemState}</h3>

        <h3 style={{ marginBottom: "0.3rem" }}>Query:</h3>
        {isSingleValue ? (
          <ul style={{ padding: 0, listStyleType: "none" }}>
            <li>{query}</li>
          </ul>
        ) : (
          <ul style={{ padding: 0, listStyleType: "none" }}>
            {queryParts.map((part, index) => {
              const [key, value] = part.split(": ");
              return (
                <li key={index}>
                  <strong>{key ? formatKey(key) : ""}:</strong> {value}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      <div className="ewarta-search-result-container">
        <div className="ewarta-search-result-body">
          <div>
            <div className="search-select-container">
              <select value={limit} onChange={handleLimitChange}>
                <option>10</option>
                <option>25</option>
                <option>50</option>
              </select>
              <TiArrowUnsorted
                className="search-custom-arrow"
                size={18}
                color="#a6a8aa"
              />
            </div>
            <span className="search-select-text">records per page</span>
          </div>
          <table className="case-law-table">
            <thead>
              <tr>
                <th style={{ minWidth: "10vw" }}>
                  <div className="egazette-search-table-header">
                    Publication Date
                  </div>
                </th>
                <th style={{ width: "10%" }}>
                  <div className="egazette-search-table-header">Page No</div>
                </th>
                <th style={{ minWidth: "20vw" }}>
                  <div className="egazette-search-table-header">Text</div>
                </th>

                <th style={{ width: "10%" }}>
                  <div className="egazette-search-table-header">Action</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((result, index) => (
                <tr key={index}>
                  <td>
                    {result?.metadata?.length > 0
                      ? new Date(
                          result.metadata[0]?.publicationDate
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                      : "Invalid Date"}
                  </td>
                  <td colSpan={2}>
                    {result.chunks?.map((chunk, chunkIndex) => (
                      <div
                        key={chunkIndex}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "10% 90%",
                          alignItems: "start",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {chunk.pageNumber}
                        </span>
                        <HighlightedText
                          paragraph={chunk.relevant_excerpt}
                          keyword={query}
                          onClick={() =>
                            openModal(result.fileUUID, chunk.pageNumber)
                          }
                        />
                      </div>
                    ))}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      fontSize: "20px",
                      color: "#0078ff",
                      justifyContent: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    <button
                      className="confirm-btn"
                      onClick={() => {
                        setAddPageNumberModalOpen(true);
                        setCurrentRequest(result);
                      }}
                    >
                      Choose Page Number
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="warta-cart-disclaimer">
            <i>Price inclusive of 8% SST</i>
          </div>
        </div>

        <Pagination
          handlePageClick={handlePageClick}
          pageCount={pageCount}
          currentPageNumber={currentPage}
          totalResult={totalResults}
          limit={limit}
          offset={itemOffset}
        />

        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          pdf={file}
          pageNumber={pageNumber}
          keyword={query}
          uuid={itemId}
        />

        {addPageNumberModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content" style={{ height: "160px" }}>
              <h2>Add page number</h2>
              <p>
                Please use comma (,) to separate the pages and hyphen (-) for
                multiple pages (without spaces)
              </p>
              <input
                type="text"
                placeholder="Example.: 3,4-8,10"
                value={requestPageNumber}
                onChange={(e) => setRequestPageNumber(e.target.value)}
                style={{
                  width: "96%",
                  padding: "8px",
                  marginBottom: "10px",
                  marginTop: "10px",
                }}
              />
              <div
                className="modal-buttons"
                style={{
                  display: "flex",
                  gap: "30px",
                  justifyContent: "space-around",
                  marginTop: "20px",
                }}
              >
                <button
                  className="confirm-btn"
                  onClick={() => {
                    validatePageNumber();
                  }}
                >
                  Confirm
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => {
                    setAddPageNumberModalOpen(false);
                    setCurrentRequest(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
}
